<template>
  <div class="text-left w-100">
    <div  id="allmap"></div>
  </div>
</template>

<script>
  export default {
    name: 'Surrounding',
    props:['DisplayBasicInfo'],
    mounted() {
      this.initMap();
    },
    watch: {
      DisplayBasicInfo() {
        this.initMap();
      }
    },
    methods: {
      initMap() {
        console.log(this.DisplayBasicInfo)
        // 百度地图API功能
        var map = new BMap.Map('allmap');            // 创建Map实例
        let point = new BMap.Point(this.DisplayBasicInfo.longitude, this.DisplayBasicInfo.latitude);
        map.addControl(new BMap.ScaleControl());
        // map.addControl(new BMap.NavigationControl({
        //   anchor:BMAP_ANCHOR_TOP_RIGHT
        // }));   //平移缩放控件
        map.centerAndZoom(point,16);  //初始化时，即可设置中心点和地图缩放级别
        map.enableScrollWheelZoom(true);  
        let marker = new BMap.Marker(point);
        map.addOverlay(marker);
        let displayTitle = this.DisplayBasicInfo.title || '';
        var label = new BMap.Label(displayTitle, {offset: new BMap.Size(20, -10)});
        marker.setLabel(label);
        map.enableDoubleClickZoom(true);
          // 禁用拖拽功能
        map.disableDragging(); 
        // 禁用滚轮缩放
        map.disableScrollWheelZoom();
        // 可选：禁用双击缩放
        map.disableDoubleClickZoom();
        // 可选：禁用键盘操作（如方向键移动、+/- 缩放）
        map.disableKeyboard();
      },
    },
  }
</script>
<style>
  #allmap {
    width: 100%;
    height: 230px;
    overflow: hidden;
    margin: 0;
    font-family: "微软雅黑";

  }
</style>